import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
import { checkCanViewFinanceModule } from '../../hooks/useHasPermission';
import { useAuth } from '../../hooks/useAuth';

/** Finance module — finance.view (manager/admin bypass in helper). */
export function FinanceViewOutlet() {
  const user = useSelector((s: RootState) => s.auth.user);
  if (!checkCanViewFinanceModule(user)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}

/** Только админ (как canManageUsers в Layout). */
export function AdminOutlet() {
  const { canManageUsers } = useAuth();
  if (!canManageUsers()) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
